<label
  [formGroup]="parentForm"
  [attr.aria-checked]="parentForm.value[controlName] === radioKey"
  [class.disabled]="control.disabled"
>
  <div
    class="flex relative regular-type radio-wrapper"
    [class.ps-small-t]="displayContainerStyles"
    [class.grey-600-text]="control.disabled"
  >
    <input
      class="is-vishidden"
      role="radio"
      [class.sensitive]="isSensitive"
      [id]="controlName + '-' + radioKey"
      type="radio"
      [attr.name]="name || controlName"
      [value]="radioKey"
      [formControlName]="controlName"
      [name]="controlName"
    />
    <span
      aria-hidden="true"
      class="flex flex--align-start ps-xxsmall-t"
      [class.nordic-blue-900-text]="!control.disabled"
      [class.grey-200-text]="control.disabled"
    >
      <fcom-icon
        *ngIf="parentForm.value[controlName] === radioKey"
        name="radiobutton-selected"
        class="radio-icon is-xxsmall"
      ></fcom-icon>
      <fcom-icon
        *ngIf="parentForm.value[controlName] !== radioKey"
        name="radiobutton-unselected"
        class="radio-icon is-xxsmall"
      ></fcom-icon>
    </span>
    <div class="ms-xsmall-l">
      <div *ngIf="description" class="label font-body-1 ps-xsmall-l inline fill">
        <div class="medium-type">{{ descriptionTitle }}</div>
        <div class="font-body-2 grey-700-text" [innerHTML]="descriptionText"></div>
        <div class="nordic-blue-900-text"><ng-content></ng-content></div>
      </div>
      <span *ngIf="!description" class="label font-body-1">
        {{ translationPrefix + '.' + radioKey | finLocalization }}
      </span>
    </div>
  </div>
</label>
